<template>
  <div class="lock_drop_call">
    <button
      class="hover_op"
      @click="
        $store.dispatch(
          'setRoomPrivacy',
          !$store.state.meeting.roomData.isPrivate
        )
      "
      :class="{ lock: isPrivate }"
      v-if="
        meetingState === 'joined-meeting' &&
        this.$store.state.meeting.localParticipant.owner
      "
    >
      <img src="@/assets/img/lock_room_icon.svg" alt="" v-if="!isPrivate" />
      <img src="@/assets/img/unlocked_icon.svg" alt="" v-if="isPrivate" />

      <span v-if="!isPrivate">Lock room</span>
      <p v-if="isPrivate"><span>Room is locked</span> Unlock room</p>
    </button>

    <div class="drop left lock_drop">
      <p>Guests need to knock to enter locked rooms.</p>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    isPrivate() {
      return this.$store.state.meeting.roomData.isPrivate;
    },

    meetingState() {
      return this.$store.state.meeting.currentState;
    },
  },
};
</script>

<style lang="scss">
</style>